import NextImage from '@/components/cms/image';
import { MediaData } from '@/components/cms/types';
import WPTypography from '@/components/typography/typography';
import { Box } from '@drivekyte/web-components';
import { useMedia } from '@drivekyte/ui';
import dayjs from 'dayjs';
import { useRouter } from 'next/router';

type PostItemProps = {
  slug: string;
  title: string;
  author: string;
  date: string;
  image: MediaData;
};

const PostItem = ({ slug, title, author, date, image }: PostItemProps) => {
  const media = useMedia();
  const isMobile = media.xs;
  const router = useRouter();

  const handlePress = () => {
    router.push(`/blog/${slug}`);
  };

  return (
    <Box
      paddingTop="tiny"
      paddingBottom="medium"
      paddingHorizontal="tiny"
      cursor="pointer"
      onPress={handlePress}
    >
      <Box display="flex" flexDirection="column">
        <NextImage
          media={image}
          width={380}
          height={250}
          borderRadius="8px"
          objectFit="cover"
        />
        <Box marginTop="xSmall">
          <WPTypography
            variant="h2"
            color="primary"
            hoverColor="quaternary"
            fontFamily="Gilroy"
            fontSize={isMobile ? 18 : 22}
            lineHeight={isMobile ? 28 : 32}
            fontWeight={600}
          >
            {title}
          </WPTypography>
          <WPTypography
            variant="h4"
            color="primary"
            fontFamily="Gilroy"
            fontSize={isMobile ? 14 : 16}
            lineHeight={isMobile ? 22 : 24}
            fontWeight={400}
          >
            {`${author} · ${dayjs(date).format('MMM D, YYYY')}`}
          </WPTypography>
        </Box>
      </Box>
    </Box>
  );
};

export default PostItem;
